import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {MatSnackBar, MatSnackBarConfig} from "@angular/material/snack-bar";

@Component({
  selector: 'flex-forgot-password',
  templateUrl: './forgot-password.component.html',
  styleUrls: ['./forgot-password.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ForgotPasswordComponent implements OnInit {
  email: string;
  snackConfig: MatSnackBarConfig = {horizontalPosition: "center", verticalPosition: "top", duration: 5000}

  constructor(private http: HttpClient, private message: MatSnackBar) { }

  ngOnInit(): void {}

  requestPassword() {
    if (this.email == null || this.email === '') {
      this.message.open('An email was not entered, please click "Forgot Password?" again and enter an email address.', 'X', this.snackConfig);
    } else {
      this.sendRequest();
    }
  }

  sendRequest(){
    this.http.get(`/api/unsecured/creditUnion/forgotPassword/${this.email}`).subscribe()
    this.message.open('Request sent! We will send your temporary password to ' + this.email, 'X', this.snackConfig)
  }
}
